import { Module } from "vuex";
import { getters } from "./getters";
import { IRootState } from "../types";
import { ActivityState } from "./types";
import { ActivityCategory } from "@dcc/types/activityCategory";
import { actions } from "./actions";
import { mutations } from "./mutations";

export const state: ActivityState = {
  [ActivityCategory.ActiveDays]: [],
  [ActivityCategory.EasyTips]: [],
  [ActivityCategory.Health]: [],
  selected: []
};

export const namespace = "activity";

const namespaced: boolean = true;

export const activity: Module<ActivityState, IRootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
